export const priceFormatter = (price) => {
    const formatter = new Intl.NumberFormat("ro-Ro", {
        style: "currency",
        currency: "RON",
    });
    return formatter.format(parseFloat(price / 100).toFixed(2));
}